import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const useErrorMsg = () => {
  const { t } = useTranslation();

  const handleErrorMessageAlert = useCallback(
    (error) => {
      switch (error?.statusCode) {
        case 400:
          return t(error?.data?.messageKey) || t('errorMessage400', { ns: 'fanz-default' });
        case 401:
          return t('errorMessage401', { ns: 'fanz-default' });
        case 402:
          return t('errorMessage402', { ns: 'fanz-default' });
        case 403:
          return t('errorMessage403', { ns: 'fanz-default' });
        case 404:
          return t(error?.data?.messageKey) || t('defaultErrorMessage', { ns: 'fanz-default' });
        default:
          return t('defaultErrorMessage', { ns: 'fanz-default' });
      }
    },
    [t],
  );

  return { handleErrorMessageAlert };
};

export default useErrorMsg;
